import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'avano-appheader-icon-area',
  template: '<ng-content></ng-content>'
})
export class AvanoAppheaderIconAreaComponent {
  @HostBinding('style.display') flexDisplay = 'flex';
  @HostBinding('style.alignItems') alignStretch = 'stretch';
}

@Component({
  selector: 'avano-appheader-middle-area',
  template: '<ng-content></ng-content>'
})
export class AvanoAppheaderMiddleAreaComponent {}
